import React from 'react';
import { Phone, MessageCircle, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="contact" className="py-24 bg-primary relative overflow-hidden" data-id="element-43">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 2px, transparent 2px)',
      backgroundSize: '40px 40px'
    }} data-id="element-44"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-46">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-8 leading-tight" data-id="element-47">
            Your Yard Won't Fix Itself. Let's Change That Today.
          </h2>

          <p className="text-xl text-white/90 mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-48">
            Call or text YEI Mateo Lawn Care for your FREE estimate. No
            pressure. No commitment. Just a real quote from a real local team.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mb-12" data-id="element-49">
            <a href="tel:6192492966" className="bg-white hover:bg-gray-100 text-primary font-bold py-5 px-10 rounded-lg transition-colors w-full sm:w-auto text-center text-lg flex items-center justify-center gap-3 shadow-lg" data-id="element-50">
              <Phone size={24} data-id="element-51" />
              CALL (619) 249-2966
            </a>
            <a href="sms:6192492966" className="bg-transparent border-2 border-white hover:bg-white/10 text-white font-bold py-5 px-10 rounded-lg transition-colors w-full sm:w-auto text-center text-lg flex items-center justify-center gap-3" data-id="element-52">
              <MessageCircle size={24} data-id="element-53" />
              TEXT US NOW
            </a>
          </div>

          <p className="text-white/80 mb-8" data-id="element-54">
            <a href="mailto:info@yeimateolawncare.com" className="hover:text-white underline transition-colors" data-id="element-55">
              info@yeimateolawncare.com
            </a>
          </p>

          <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-white/80 font-medium" data-id="element-56">
            <div className="flex items-center gap-2" data-id="element-57">
              <CheckCircle2 size={20} className="text-accent" data-id="element-58" />
              <span data-id="element-59">Free Estimate</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-60">
              <CheckCircle2 size={20} className="text-accent" data-id="element-61" />
              <span data-id="element-62">No Hidden Fees</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-63">
              <CheckCircle2 size={20} className="text-accent" data-id="element-64" />
              <span data-id="element-65">Local San Diego Team</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-66">
              <CheckCircle2 size={20} className="text-accent" data-id="element-67" />
              <span data-id="element-68">All Services Covered</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}